import { DraggableKanbanBoard } from "./DraggableKanbanBoard";
import { useKanbanMatches } from "@/hooks/matches/useKanbanMatches";
import { KANBAN_STAGES } from "./types/index";
import { useTranslation } from "react-i18next";

interface SharedKanbanBoardProps {
	jobId?: string;
	candidateId?: string;
	showAllMatches?: boolean;
	pointOfView?: "job" | "candidate";
}

export const SharedKanbanBoard = ({ jobId, candidateId, showAllMatches = false }: SharedKanbanBoardProps) => {
	const { t } = useTranslation();
	const { loading, matches, handleStageChange } = useKanbanMatches({ 
		jobId, 
		candidateId, 
		showAllMatches 
	});

	// Group matches by their stage
	const candidatesByStage = KANBAN_STAGES.reduce((acc, stage) => {
		acc[stage.id] = matches.filter(m => m.stage === stage.id);
		return acc;
	}, {} as Record<string, typeof matches>);

	if (loading) {
		return (
			<div className="flex justify-center p-8">
				<div className="animate-spin h-8 w-8 border-2 border-digger-blue border-t-transparent rounded-full"></div>
			</div>
		);
	}

	return (
		<div className="w-full overflow-x-auto">
			<DraggableKanbanBoard
				stages={KANBAN_STAGES}
				candidatesByStage={candidatesByStage}
				onCandidateDrop={handleStageChange}
			/>
		</div>
	);
};
